import { apiSlice } from "../../../features/api/apiSlice";

function pick(res: any) {
  return res?.data?.data ?? res?.data ?? res;
}
function pickArr(res: any): any[] {
  const d = pick(res);
  return Array.isArray(d) ? d : [];
}

export const adminExamCoursesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    adminGetCourses: builder.query<any[], void>({
      query: () => "/exam/admin/courses",
      transformResponse: (res: any) => pickArr(res),
      providesTags: [{ type: "AdminExamCourses" as const, id: "LIST" }],
    }),

    adminGetCoursesByExam: builder.query<any[], string>({
      query: (examId) => `/exam/admin/courses?exam_id=${examId}`,
      transformResponse: (res: any) => pickArr(res),
      providesTags: (_, __, examId) => [{ type: "AdminExamCourses" as const, id: `exam-${examId}` }],
    }),

    adminGetCourseDetails: builder.query<any, string | number>({
      query: (id) => `/exam/admin/courses/${id}`,
      transformResponse: (res: any) => pick(res),
      providesTags: (_, __, id) => [{ type: "AdminExamCourses" as const, id: String(id) }],
    }),

    adminCreateCourse: builder.mutation<any, { exam_id?: string; name: string; code: string; description?: string; has_multiple_papers?: boolean }>({
      query: (body) => ({ url: "/exam/admin/courses", method: "POST", body }),
      invalidatesTags: (_, __, { exam_id }) => [
        { type: "AdminExamCourses" as const, id: "LIST" },
        ...(exam_id ? [{ type: "AdminExamCourses" as const, id: `exam-${exam_id}` }] : []),
      ],
    }),

    adminUpdateCourse: builder.mutation<any, { id: string | number; body: Partial<{ exam_id: string; name: string; code: string; description: string; is_active: boolean; has_multiple_papers: boolean }> }>({
      query: ({ id, body }) => ({ url: `/exam/admin/courses/${id}`, method: "PUT", body }),
      invalidatesTags: (_, __, { id }) => [
        { type: "AdminExamCourses" as const, id: "LIST" },
        { type: "AdminExamCourses" as const, id: String(id) },
      ],
    }),

    adminDeleteCourse: builder.mutation<any, string | number>({
      query: (id) => ({ url: `/exam/admin/courses/${id}`, method: "DELETE" }),
      invalidatesTags: [{ type: "AdminExamCourses" as const, id: "LIST" }],
    }),

    adminGetCourseDietDetails: builder.query<any, { courseId: string | number; dietId: string | number }>({
      query: ({ courseId, dietId }) => `/exam/admin/courses/${courseId}/diet/${dietId}`,
      transformResponse: (res: any) => pick(res),
      providesTags: (_, __, { courseId, dietId }) => [
        { type: "AdminExamCourses" as const, id: `${courseId}:${dietId}` },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useAdminGetCoursesQuery,
  useAdminGetCoursesByExamQuery,
  useAdminGetCourseDetailsQuery,
  useAdminCreateCourseMutation,
  useAdminUpdateCourseMutation,
  useAdminDeleteCourseMutation,
  useAdminGetCourseDietDetailsQuery,
} = adminExamCoursesApi;
